import React from 'react';
import KoobCopy from './KoobCopy';
import cn from '../utils/cn';

type KoobIdProps = {
  /** Numeric or string identifier; renders nothing when missing. */
  id?: string | number | null;
  /** Extra classes on the trigger, e.g. spacing. */
  className?: string;
};

/**
 * Small muted monospace "#id" label that copies the raw id on click.
 * Sits next to or under a product name in cards, tables and headers.
 */
export default function KoobId({ id, className }: KoobIdProps) {
  if (id === undefined || id === null || id === '') {
    return null;
  }

  return (
    <KoobCopy
      value={String(id)}
      className={cn('text-xs font-normal leading-none', className)}
    >
      <span className="font-mono text-muted-foreground">#{id}</span>
    </KoobCopy>
  );
}
